import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getOfferte = (target) =>
  axios.get(`${API}/offerte`, { params: target ? { target } : {} }).then((r) => r.data);

export const getOfferta = (marca, modello) =>
  axios.get(`${API}/offerte/${marca}/${modello}`).then((r) => r.data);

export const inviaPreventivo = (data) =>
  axios.post(`${API}/preventivi`, data).then((r) => r.data);
